import React from 'react';
import { ToastContainer as OriginalToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function ToastContainer(props) {
  return <OriginalToastContainer />
}


